
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sobre-nosotros",
      function () {
        return require("private-next-pages/sobre-nosotros/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sobre-nosotros"])
      });
    }
  